export const PRODUCT_TYPE = {
  PLAN: 'plan',
  ADDON: 'addon',
}

export const PLAN_NAME = {
  FREEMIUM: 'Freemium',
  STARTER: 'Starter',
  PRO: 'Pro',
  ENTERPRISE: 'enterprise',
  PAY_AS_YOU_GO_CREDITS: 'Pay As You Go Credits',
}

export const CURRENCY = {
  USD: {
    // flag: require("../../src/static/svg/us_flag.svg"),
    symbol: '$',
    name: 'USD',
    locale: 'en-US'
  },
  INR: {
    // flag: require("../../src/static/svg/in_flag.svg"),
    symbol: '₹',
    name: 'INR',
    locale: 'en-IN'
  }
}

export const MAX_CREDIT_BUY = 20000000
export const FREEMIUM_PRODUCT_ID = '241095070400180595110500'

export const FEATURE_GROUP_TOOLTIPS = {
  'Email Verifier': '1 Credit charged per Billable Email',
  'Email Finder': '4 Credits charged per non Role-based Email Found / 2 Credits charged per Role-based Email Found',
  'Prospecting': '4 Credits charged per non Role-based Email / 2 Credits charged per Role-based Email and 2 Credits for Phone Number'
}

export const ENTERPRISE_CARD_DATA = {
  tagline: "Premium features with customized plan",
  description: "Customize plan as per your scale",
  features: [
    { description: "Dedicated Account Manager" },
    { description: "Priority Technical Support" },
    { description: "10M+ Volume Commitment" },
    { description: "On-Premise Deployment" },
    { description: "Whitelabel & Rebranding" },
    { description: "Beta Access Eligibility" },
    { description: "Free Future Updates" },
    { description: "Advanced Analytics & Reporting" },
    { description: "Multitier Security and Governance" },
    { description: "Unlimited Team Seats" },
    { description: "Custom Support & Training" },
    { description: "Flexible Contract Terms" },
  ],
  short_name: "Enterprise",
}